(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mellow-rush-events"] && !Shopify.designMode) return;
  try {
    
if (!document.documentElement.hasAttribute('data-mrevents-lightbox-ready')) {
  document.documentElement.setAttribute('data-mrevents-lightbox-ready', 'true');

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-mrevents-lightbox-open]');
    if (opener) {
      var section = opener.closest('.mrevents');
      var dialog = section && section.querySelector('[data-mrevents-lightbox]');
      var image = dialog && dialog.querySelector('.mrevents__lightbox-image');

      if (dialog && image) {
        image.src = opener.getAttribute('data-full-src');
        image.alt = opener.getAttribute('data-alt') || '';
        dialog.showModal();
      }
      return;
    }

    var closer = event.target.closest('[data-mrevents-lightbox-close]');
    if (closer) {
      closer.closest('dialog').close();
      return;
    }

    if (event.target.matches('[data-mrevents-lightbox]')) {
      event.target.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
